import { message } from 'antd';
import { TECHNIC_PREFIX } from '../../../config/technicPrefix';
import { urls } from '../../../config/url';
import { IJob, IJobListen, JobStatus } from '../../../redux/progress/job/jobReducer';
import { IJobName } from '../../../redux/progress/jobname/jobnameReducer';
import { IModule } from '../../../redux/progress/module/moduleReducer';
import { IModuleParams } from '../../../redux/progress/param/paramReducer';
import httpRequest from '../../../utils/HttpRequest';

export default function useUpdateParam(
    userName: string,
    projectName: string,
    lineName: string,
    updateParam: (param: IModuleParams,) => void,
    setRunningIndex: (runningIndex: number) => void,
    refreshJobs: (jobs: IJobListen) => void,
    setActiveModule: (activeindex: number) => void,
    tech: string,
    jobnameUpdate: (jobnames: IJobName) => void,
    modules: IModule,
    params: any
): () => Promise<void> {

    if (lineName === '') return async () => {
        refreshJobs({});
        setRunningIndex(0);
        setActiveModule(0);
        jobnameUpdate({});
    };


    return () => {
        return httpRequest(urls.getProjParams, {
            USER_NAME: userName,
            PROJECTNAME: projectName,
            proj_name: lineName,
            TECHNIC_PREFIX: (TECHNIC_PREFIX as any)[tech]
        }).then(response => {
            if (response.data.errno === 0) {

                const defaultParam: any = {}
                const useparam: any[] = []
                
                
                modules.modules.forEach((module) => {
                    module.PRO_MODULE_PARAMS.forEach(param => {
                   
                        if (param.hasOwnProperty("USEADVISEPARAM") || param.USEADVISEPARAM === false) {
                            useparam.push(param.PARAMNAME)
                        }
                        defaultParam[param.PARAMNAME] = param.PARAMDEFAULTVALUE;

                    })
                })

                if (params != '') {
                    response.data.data.MODULEPARAMS.proj_name = params['proj_name']
                    useparam && useparam.map((item, i) => {

                        response.data.data.MODULEPARAMS[item] = params[item]
                    })
                }

                updateParam(Object.assign(defaultParam, response.data.data.MODULEPARAMS));

                let infoArray: string[] = response.data.data.MODULEARRAY;
                let job: IJob = {
                    stop: () => { },
                    info: {
                        status: JobStatus.complete,
                        jobName: '',
                        viewer: []
                    }
                };
                let joblisten: IJobListen = {};
                for (let name of infoArray) {
                    joblisten[name] = job;
                }
                refreshJobs(joblisten);

                setRunningIndex(response.data.data.MODULEARRAY.length);
                // setActiveModule(0);

                jobnameUpdate(response.data.data.MOUDLELASTJOBMAP);
            } else {
                message.error(response.data.errmsg);
            }
        })
    }
}